
export type SortByParamParameter = typeof SortByParamParameter[keyof typeof SortByParamParameter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortByParamParameter = {
  createdAt: 'createdAt',
  likeCount: 'likeCount',
  retweetCount: 'retweetCount',
  viewCount: 'viewCount',
} as const;
